
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index5KVldyFMYWY_45brh_45RgytIP5hDSTN6fSjoHd5KWp5trkMeta } from "/app/client/pages/index.vue?macro=true";
import { default as _91_46_46_46all_93pKmfkv_45_qxB75c2vYOrNkmQsJahOIdnb4eczlNrA7_45UMeta } from "/app/client/pages/[...all].vue?macro=true";
import { default as indexDijXZ1aXr1u2YPHB3lr_45QRSOp_45Rb_jNx7KPiGWOPLwUMeta } from "/app/client/pages/events/index.vue?macro=true";
import { default as createKVlgTCIaMqAhaigvqwVweE7pSzAynrN8EHrortkW0isMeta } from "/app/client/pages/events/create.vue?macro=true";
import { default as indexdQ_45tYUVXcZFaqsgneU3nvJZcawlth2WfnGy6De2zPzkMeta } from "/app/client/pages/planner/index.vue?macro=true";
import { default as indexHwWEi01n3CfdgfbpvVOmM_45PIcX2UcniXpxozQjANFpkMeta } from "/app/client/pages/audience/index.vue?macro=true";
import { default as indexLW1JiVyGFsz9hEZzyDe0sn6q6czN97zfTCAbqGwEIYwMeta } from "/app/client/pages/campaigns/index.vue?macro=true";
import { default as createsUtMw9F1u1FRyvP8nfijeaxcbv5YasLIuCTlEsPAP7kMeta } from "/app/client/pages/campaigns/create.vue?macro=true";
import { default as indexHQjmLZQ9EbbaO97SSGXBUL_0iBU0AJw6spNmtU4fmFoMeta } from "/app/client/pages/events/past/index.vue?macro=true";
import { default as loginxYk8MozFkQw3Cic938tQ9Awd8evFkRosM9Pbsi9Tnt0Meta } from "/app/client/pages/authenticate/login.vue?macro=true";
import { default as indexA5f7UsyHU_45EVhLOlgibregOgjCg5Qsem9X1U2dr4BDcMeta } from "/app/client/pages/audience/tags/index.vue?macro=true";
import { default as signupFSIhzbPheX6XOnsBQ6gnwVeAiG_uQ71Y5w106JsskmwMeta } from "/app/client/pages/authenticate/signup.vue?macro=true";
import { default as _91oid_93TtxGKviyPOXNFJeFrxShISfz5QDJcpEzz1RgtUxnLcYMeta } from "/app/client/pages/campaigns/view/[oid].vue?macro=true";
import { default as index_N7wXZeknd0PJBwMkF4eQxRqkb9tSUeMgzqxtHmJIqYMeta } from "/app/client/pages/custom-planner/index.vue?macro=true";
import { default as indexDwsMnyjX2lqY3nSXX0lFdzmnt6iMByXrMt_g0qdsaSYMeta } from "/app/client/pages/events/archived/index.vue?macro=true";
import { default as indexiXIXuwQxg7D8DEX4_X7sRkIccLZQHke5qu3S4dDB8R0Meta } from "/app/client/pages/audience/filters/index.vue?macro=true";
import { default as _91oid_93UIYvXjZ6N8tpOO2whwOitHWnMGRTJr4K9dWR6yMzzFAMeta } from "/app/client/pages/campaigns/update/[oid].vue?macro=true";
import { default as signupsYSs7_seJ2ubLMZX_3PzchGtZpOTIxx1e8lyHD3ywMQkMeta } from "/app/client/pages/campaigns/view/signups.vue?macro=true";
import { default as editZsIRnJBGv7Krq0HQ19r_YcFiA06nbNhWZms_45Yw835oQMeta } from "/app/client/pages/events/[eventoid]/edit.vue?macro=true";
import { default as email_45examplesvuFcGHglpyH0x_uM68_45cMIhFxdU8atHwhXszujXrnMMeta } from "/app/client/pages/campaigns/email-example.vue?macro=true";
import { default as insightsONCk6ofDS9OziGlMoYHhvoqMaPxCAVcpLXyzpO1_45CosMeta } from "/app/client/pages/campaigns/view/insights.vue?macro=true";
import { default as indexF3NxUgCT9WgIXkflZXtTqOs19JTb_45aStXpOCh3X5DiEMeta } from "/app/client/pages/events/composables/index.ts?macro=true";
import { default as dashboardSdlzGlyuLIz61J8qESlpFWebkOJClt9hFI9m5Zocm_UMeta } from "/app/client/pages/campaigns/view/dashboard.vue?macro=true";
import { default as email_45verifyPOV3rBQlOtrpZCbXE81p5ZQjYR8dAB6mwAtb0IM7jSkMeta } from "/app/client/pages/authenticate/email-verify.vue?macro=true";
import { default as index6CgMYCh46D43Ow9RSDw9UOM2Q4BpW72efpLEhJJNs_8Meta } from "/app/client/pages/authenticate/invite/index.vue?macro=true";
import { default as calendarItemsemQimCq8ZmoY3fgwoz1Zfc9vRgsJXB7SUQEXZ_s8fUoMeta } from "/app/client/pages/events/types/calendarItems.ts?macro=true";
import { default as criteriaMenuguiWufSddJg0dxlXaDRw66Hly5dnbRbMkijMwV4HiJIMeta } from "/app/client/pages/audience/utils/criteriaMenu.js?macro=true";
import { default as filterNamingvtGwJ5qOd0Ex4btmXA5sVX5w_453YAKBOCTLBqWToIVocMeta } from "/app/client/pages/audience/utils/filterNaming.ts?macro=true";
import { default as ResetPassworddPj4UFT2XJeow4WhfEhDNpchOpPlWoPF0F13yYazjMkMeta } from "/app/client/pages/authenticate/ResetPassword.vue?macro=true";
import { default as billing_45detailsooHyWJ5gAlFd_kKSw8d6_45fyedi8aw7gbetskHL6AR4kMeta } from "/app/client/pages/authenticate/billing-details.vue?macro=true";
import { default as forgot_45passwordIZH7K9m_45cg_45MtiHuvxAyhT5smHi3xhJVQ4lf96fgXLQMeta } from "/app/client/pages/authenticate/forgot-password.vue?macro=true";
import { default as registrationsJ59Nuv2Dp_459Vb33vUYTPObLINI3b77yuTmNLhSl_j0wMeta } from "/app/client/pages/campaigns/view/registrations.vue?macro=true";
import { default as eventzi97_sMJR6647TqN6hxICt63CHyTweS_45tFzEd4LrdpQMeta } from "/app/client/pages/events/[eventoid]/view/event.vue?macro=true";
import { default as groupwgEAus6Z2zATxmv3l3bztlM3K3QfgBnnRF1_2XOqO7MMeta } from "/app/client/pages/events/[eventoid]/view/group.vue?macro=true";
import { default as data_45capture_45examplenwlRX9Vw0B6_45XIBW_nkFQz7mnGAB3OFt4e0CWDboKqEMeta } from "/app/client/pages/audience/data-capture-example.vue?macro=true";
import { default as indexqexma7ADh2vXbn9cvslhGem0VLqwTs15sdMEhdW63z4Meta } from "/app/client/pages/audience/[customer]/view/index.vue?macro=true";
import { default as FilterTabs_45zhgGNJ21sFch4TyMsHY5XfUZ3yY5EJOIWWhVy_PHRMMeta } from "/app/client/pages/audience/components/FilterTabs.vue?macro=true";
import { default as import_45sales_45datanz5Y8tK_Q80RzKTiCTexWVLFbAzxEhC0XAVDHLopHvAMeta } from "/app/client/pages/authenticate/import-sales-data.vue?macro=true";
import { default as indexfk8ccYChg2E5_45ykfCIgQfz7GoYwWhUXsOmZh5kLiDE4Meta } from "/app/client/pages/authenticate/invite-sent/index.vue?macro=true";
import { default as EditEventGroupDrPSZQI9PBdt2x4wdZgfvDiBUsXJUMQWP9IUqsru0wEMeta } from "/app/client/pages/events/components/EditEventGroup.vue?macro=true";
import { default as OrdersTabDPFM3L3inLjamqAK_kk6Z4CMaWfNbfSgHgpy5upJneUMeta } from "/app/client/pages/events/components/view/OrdersTab.vue?macro=true";
import { default as FilterTagListPTpPuXWAkcUB6B6TfVzksFNHqzs9qrAEo4eqKOUdwywMeta } from "/app/client/pages/audience/components/FilterTagList.vue?macro=true";
import { default as index2wvfFmwjiUed9YNFEtfwKf4HER9NDBly_GGBGlDdKG4Meta } from "/app/client/pages/authenticate/invite-expired/index.vue?macro=true";
import { default as campaigns7w1gIUhDmMlXDRnaMcmQVdicnXzCJYuep7LIe_KW7FkMeta } from "/app/client/pages/audience/[customer]/view/campaigns.vue?macro=true";
import { default as FavoriteButtonci9qiOwNjJg2WmtMTmc9l1CZukY1XLRGhxITkGD91BAMeta } from "/app/client/pages/audience/components/FavoriteButton.vue?macro=true";
import { default as FilterListItemh7oIC5k5s_ZfZqwEQU5dGoJAbcloszHtxvJ3gMDYUucMeta } from "/app/client/pages/audience/components/FilterListItem.vue?macro=true";
import { default as useTagCreation_mph_45PIKOg5Jy3S_45ROjQLblfltrPab6_q6gsIbo_xZ8Meta } from "/app/client/pages/audience/composables/useTagCreation.js?macro=true";
import { default as GroupEventsModalS1LXXcQ15jpO_45DpPKGpz0XSeSXoXqJcPD5LZzWjneS8Meta } from "/app/client/pages/events/components/GroupEventsModal.vue?macro=true";
import { default as InsightsTabSGqL0ZUzivVzxIE9m0CoGLmg_45leiAZDoaIhqv__45_450KgMeta } from "/app/client/pages/events/components/view/InsightsTab.vue?macro=true";
import { default as MessagesTab2k_45UKGLeV1knXtGSEXqDHBREIKR0n_nBHvSP5I8bMjIMeta } from "/app/client/pages/events/components/view/MessagesTab.vue?macro=true";
import { default as useEventMessagesJ28U54eN0hs6AavBiUAAdpkpW7CXYp4V6jbol_GbUI0Meta } from "/app/client/pages/events/composables/useEventMessages.ts?macro=true";
import { default as AudienceFiltersdL01shNP7Cam_45XUPbvZQRbS5nlDZPji9BNc7F_45kzlawMeta } from "/app/client/pages/audience/components/AudienceFilters.vue?macro=true";
import { default as AddActionModal1fEq1F3g3Fy96bv7UlZyLoXnL1p8VJUYL0nu41quCosMeta } from "/app/client/pages/campaigns/components/AddActionModal.vue?macro=true";
import { default as AddRewardModaltep2pDU2JKOtaKskMwjKv8EH_45q_45SiI5xaXCwiAGdP1EMeta } from "/app/client/pages/campaigns/components/AddRewardModal.vue?macro=true";
import { default as CampaignHeaderwMu5B902TfXKbg1vovGLtYarNwfgHxfVRE2qak38CN0Meta } from "/app/client/pages/campaigns/components/CampaignHeader.vue?macro=true";
import { default as EditFieldModaliTYFMzYGIS3iDL9Ig0iGHCTxFym8Nx3EJgt8nNdbeVkMeta } from "/app/client/pages/campaigns/components/EditFieldModal.vue?macro=true";
import { default as DeleteEventsModalZK6msOyGi0b8XceMSAt1j6xN6lyu7OLAC7_NccXftUsMeta } from "/app/client/pages/events/components/DeleteEventsModal.vue?macro=true";
import { default as ImportEventsModal2IrTROpTqtdh_JlcXzd8jBXAc4zvtzQ0hceqEy_45aa_45YMeta } from "/app/client/pages/events/components/ImportEventsModal.vue?macro=true";
import { default as useEventCampaignsnQe_zRdOcfZbnHb0zROZBSOspX9LB6AlOV7R2T8Wf8AMeta } from "/app/client/pages/events/composables/useEventCampaigns.ts?macro=true";
import { default as PlannerDayDrawerJQkbxe1yMvBPUcg8MdPx0f1h_BDO5sBEQfkJnOQNRWAMeta } from "/app/client/pages/planner/components/PlannerDayDrawer.vue?macro=true";
import { default as ContactFormModal1JTYlu2a3Njo452x0_45hPlT6zl_45PeZVSvKQ57Lgsb_45mgMeta } from "/app/client/pages/audience/components/ContactFormModal.vue?macro=true";
import { default as EditFanTagsModalk2cVcUxgDOw_IlkfzM30EnF8Z0S9pAJMUA9x7oyBVasMeta } from "/app/client/pages/audience/components/EditFanTagsModal.vue?macro=true";
import { default as FanMassEditModalqUo6djG0x5LQPynTm4PbYAm3V7INObPgwRF2_EGBqgAMeta } from "/app/client/pages/audience/components/FanMassEditModal.vue?macro=true";
import { default as useActiveFiltersx8zFZwDyPkQKS3To4ouigsnJ_OcsHbtsP9pM5MAuD8IMeta } from "/app/client/pages/audience/composables/useActiveFilters.js?macro=true";
import { default as connect_45cardwvOefAElG85nR_45EoF_zrkFvcwj0wN_45NFI5jAmpChaYEMeta } from "/app/client/pages/authenticate/components/connect-card.vue?macro=true";
import { default as EditActionModalUtoJCSMZJHk3afHDLZ_45x6Fa1V_vVWjCVWukJ6e4GcNAMeta } from "/app/client/pages/campaigns/components/EditActionModal.vue?macro=true";
import { default as EditButtonModalVevM6YpFzKpl5Z63I5vUA38JOki9l2UpMUH_ZSjEzo0Meta } from "/app/client/pages/campaigns/components/EditButtonModal.vue?macro=true";
import { default as useGamification5FGdV77NTFHWqrJaqFGnMbQLGEJWBnNPw9PMLCSWQzgMeta } from "/app/client/pages/campaigns/composables/useGamification.js?macro=true";
import { default as ArchiveEventsModalLDIUim0TwtzNyjOCxAUIOnj7mFvJZBnutNKJFW4xh08Meta } from "/app/client/pages/events/components/ArchiveEventsModal.vue?macro=true";
import { default as posPurchasesriFZnWReTLc7hebabjLdKrNA5ucllPEThbD29OVUEaAMeta } from "/app/client/pages/audience/[customer]/view/posPurchases.vue?macro=true";
import { default as useContactColumnsZU1_45Yyd7EmVEQIwzElXnh0ze5gez6qrY8yXrWo39wGMMeta } from "/app/client/pages/audience/composables/useContactColumns.ts?macro=true";
import { default as AdvancedSettingsl7CHXbZ32Gx_JgcYWsU4p3N5fpUWkulJ6r2sVH6ihoIMeta } from "/app/client/pages/campaigns/components/AdvancedSettings.vue?macro=true";
import { default as useCampaignLogiciUSkzPeHrGjEGpQoK43rDKj1XpraWtUwFzulDEQMVpYMeta } from "/app/client/pages/campaigns/composables/useCampaignLogic.js?macro=true";
import { default as DataCaptureTabQCqkw_spndaLFj3oX7Xa49oa17JjW3zF8IS9X6jVQVQMeta } from "/app/client/pages/events/components/view/DataCaptureTab.vue?macro=true";
import { default as TicketSalesTabyjatGlGr4Gb1frm4Xnj6Eh2gz3z6fg0aSd0ZpLaXJ4oMeta } from "/app/client/pages/events/components/view/TicketSalesTab.vue?macro=true";
import { default as FanMassDeleteModaldPg3S3ZE6pvijOPNp2kDA9IbVJIOLkBgURn4z6wEeUsMeta } from "/app/client/pages/audience/components/FanMassDeleteModal.vue?macro=true";
import { default as useAdvancedFiltersTKCsIko27BJ349GNWg1gKTZAwzXOFhpn81LE88w0oDkMeta } from "/app/client/pages/audience/composables/useAdvancedFilters.js?macro=true";
import { default as useResourceOptionsJ_nNtEvBUgIumOk9X8jKgvH4G1TozGj5n2l_45S7NJk9wMeta } from "/app/client/pages/audience/composables/useResourceOptions.js?macro=true";
import { default as EditCheckboxModaleLBlP7WPJYvoujy2vtRSVMlBDSwluFIt_45n_45PHIoSySkMeta } from "/app/client/pages/campaigns/components/EditCheckboxModal.vue?macro=true";
import { default as GamificationStatssqRdrHTcxhY5ZOaojOKYEOcjYbP2D2FOW8_45kyLf1nhsMeta } from "/app/client/pages/campaigns/components/GamificationStats.vue?macro=true";
import { default as RedirectDelayCard_45rossjv_NvsPS8UzqKnZHK9Rjjl7jkKsgXtr99GfjxAMeta } from "/app/client/pages/campaigns/components/RedirectDelayCard.vue?macro=true";
import { default as DuplicateEventsModalhCClRLjWZ3D_45v2RrJoS0t_uxRFtuiJnzNICQY_45fOl_45oMeta } from "/app/client/pages/events/components/DuplicateEventsModal.vue?macro=true";
import { default as useEventDataCapturesw0zCDMUQwvgarNebelOS26BOg_45qJ61A_FvdtAuGWyDYMeta } from "/app/client/pages/events/composables/useEventDataCaptures.ts?macro=true";
import { default as useMarketingCalendarxy6MEXTTeeaSfoDNjKY1gC7EnqXXTLPepfJCkWV8_eQMeta } from "/app/client/pages/events/composables/useMarketingCalendar.ts?macro=true";
import { default as AudienceFilterGroupoAVnjZkw_z7eZxTZEKg3VbuwThz5bxa4_cqzQG9EShEMeta } from "/app/client/pages/audience/components/AudienceFilterGroup.vue?macro=true";
import { default as useResourceFetchers3QKGBoxzaYq8R5xFVdIfEBF1llG5tvooJXro9zRBhNMMeta } from "/app/client/pages/audience/composables/useResourceFetchers.js?macro=true";
import { default as GroupTagsModal1g4JQ_45WYFikM26IA3nPMsJy_450_VWzNnDIwKELwIPsEkMeta } from "/app/client/pages/audience/tags/components/GroupTagsModal.vue?macro=true";
import { default as MergeTagsModaljbhl7TyRs_45wK9ZqwSRNYmoLi8bfgX7_tA3EAScL0HBwMeta } from "/app/client/pages/audience/tags/components/MergeTagsModal.vue?macro=true";
import { default as DesktopLayoutModaligURGiygJ11ks4umj1jFTfs8kFzJnQBujf7oSp1HB_45oMeta } from "/app/client/pages/campaigns/components/DesktopLayoutModal.vue?macro=true";
import { default as InviteFriendsModalDQjVJTiTXRpbdw1hCKN8BcbMu936etBUOYsB2NCUwcgMeta } from "/app/client/pages/campaigns/components/InviteFriendsModal.vue?macro=true";
import { default as useCampaignActionsOlN1n_fvIwavGBb70Tj_zF4XvvPJT_S2lqti6uPFaw8Meta } from "/app/client/pages/campaigns/composables/useCampaignActions.ts?macro=true";
import { default as useEventCustomEntries4MAxPqZaHqCtjtoTadmNTWhUm72thNa4sCGyXsKMCGkMeta } from "/app/client/pages/events/composables/useEventCustomEntries.ts?macro=true";
import { default as ticketPurchasesDU_45EsyL3fKxMEmpp45VUKW5AzT6h270dCqHTnyAEVU4Meta } from "/app/client/pages/audience/[customer]/view/ticketPurchases.vue?macro=true";
import { default as useFilterCompression0oKzSxIPHsRxfIcwKppjXIdm0keXUS_459bly6ygZxpoUMeta } from "/app/client/pages/audience/composables/useFilterCompression.ts?macro=true";
import { default as DeleteTagsModalBQTONUuVq8kZsBhtejkcTxWNAmFdtlGfJR0Y6_457kW_45UMeta } from "/app/client/pages/audience/tags/components/DeleteTagsModal.vue?macro=true";
import { default as RenameTagsModalJhE8DieOJ_rTCsqs2d3OqdL_4h6hE2LTshbsF2cJVpgMeta } from "/app/client/pages/audience/tags/components/RenameTagsModal.vue?macro=true";
import { default as AddCustomFieldModal4dOwfuhLOsYOey7vgXcJmx0u5U0mT60Nm9AY4L9AJzIMeta } from "/app/client/pages/campaigns/components/AddCustomFieldModal.vue?macro=true";
import { default as DeleteCampaignModaltRuWyN6jv9lhgR_45BwZ5XGF_45UyUw_45wJ04kZJajf8SsJAMeta } from "/app/client/pages/campaigns/components/DeleteCampaignModal.vue?macro=true";
import { default as ClearTicketOrdersModalQkuNI7ZqBzsQ2GHQfgzpMbimSroLqWPiVbMHS33DpAIMeta } from "/app/client/pages/events/components/ClearTicketOrdersModal.vue?macro=true";
import { default as FilterConstraintInputvlFXOsJDtHjOtESRmolSBxQ2G6sQPzHY9ppouPiGekYMeta } from "/app/client/pages/audience/components/FilterConstraintInput.vue?macro=true";
import { default as CampaignPreviewFrameV7HqtzZ4Ykjk2IEzV_45DGVzTDuSXDaavumvHofus_45HUIMeta } from "/app/client/pages/campaigns/components/CampaignPreviewFrame.vue?macro=true";
import { default as CampaignTypeSelector7cFkPYlIpZy589Zei5KjejVza1PxK2ebwuBkxXlltwUMeta } from "/app/client/pages/campaigns/components/CampaignTypeSelector.vue?macro=true";
import { default as ImportTicketOrdersModalQOWpuQJYYkvZ8n96MFlmbDVz9jfBNSzUFtG53uglZjIMeta } from "/app/client/pages/events/components/ImportTicketOrdersModal.vue?macro=true";
import { default as events2DRd6RkX6fW1l_lrvCqEBlrDfiRS0uIZSuKfsZobJoQMeta } from "/app/client/pages/audience/[customer]/view/components/events.vue?macro=true";
import { default as CampaignSignUpSectionscEMNDE1wCC9uwUz1BYXE7wcTQA6lDogtNaH3_45_PaIsMeta } from "/app/client/pages/campaigns/components/CampaignSignUpSection.vue?macro=true";
import { default as MarketingPlannerTab_45v3i5oxuQGHiweIXEVBtk2n7PzXqBdBG5zB4BUt9yPoMeta } from "/app/client/pages/events/components/view/MarketingPlannerTab.vue?macro=true";
import { default as AudienceAdvancedFiltersIl3O952JAzNY3BrGkTdRBKOZcIC1Ra5RWjapNnzjCI4Meta } from "/app/client/pages/audience/components/AudienceAdvancedFilters.vue?macro=true";
import { default as AudienceFilterConditionxoQcFpwiyOt7u0dDgfxayLEsi5hq8ZUfNYpVQGrwUPYMeta } from "/app/client/pages/audience/components/AudienceFilterCondition.vue?macro=true";
import { default as AudienceFilterGroupItemuADx_45EbHDb_ibKhvamQtyLJQlktqP82KPMgIqNkYEYkMeta } from "/app/client/pages/audience/components/AudienceFilterGroupItem.vue?macro=true";
import { default as CampaignDetailsSectionS4lgC5PBdVXbQs8CIGcJYNVkPimWH0oKumnrJiLC9_45cMeta } from "/app/client/pages/campaigns/components/CampaignDetailsSection.vue?macro=true";
import { default as activityAwoLBgJzWV6ff5zH6KgjIKSrHmSXOVWqWhV6pWJFg0kMeta } from "/app/client/pages/audience/[customer]/view/components/activity.vue?macro=true";
import { default as overviewerXaxOJU4s5XEdt64gRACIUD4dDVuqUr9_LFmJQ_KocMeta } from "/app/client/pages/audience/[customer]/view/components/overview.vue?macro=true";
import { default as AddFanToMessageListModalsucHL89Iy87Fbg5xLUlavoeFFCZiqtY5UFwhOsw26y4Meta } from "/app/client/pages/audience/components/AddFanToMessageListModal.vue?macro=true";
import { default as FilterConstraintSelectordIuObbXFgi3_457Ec7nOuGJHn7Bakj6vPe6Px0z2lFPlAMeta } from "/app/client/pages/audience/components/FilterConstraintSelector.vue?macro=true";
import { default as purchasesi1Oez1sMpo3bxEWTVAMl_45j0Ru_upxe4QBqRKAuVh_HQMeta } from "/app/client/pages/audience/[customer]/view/components/purchases.vue?macro=true";
import { default as DeleteFilterModalaNtn5WgPizKLgd7K93JenLvMsIBsGyddK5hHzROnGAIMeta } from "/app/client/pages/audience/filters/components/DeleteFilterModal.vue?macro=true";
import { default as RenameFilterModalF_45z2YvFqGBICdyKEAZwHGyu8R78MJciRh5baR7e6udAMeta } from "/app/client/pages/audience/filters/components/RenameFilterModal.vue?macro=true";
import { default as conditionSearchPickerResolutionI5gA4Xfm05FD5xCvKt88lbRCNaRx5ATjYa24TkUc6BwMeta } from "/app/client/pages/audience/utils/conditionSearchPickerResolution.js?macro=true";
import { default as CreateCampaignWidgetModal5nkyUH81JpMqzaBPsXRJWfBsNviUP_7J0YbIoyjtma8Meta } from "/app/client/pages/campaigns/components/CreateCampaignWidgetModal.vue?macro=true";
import { default as useAccountMarketingCalendarTcIgargMfeH8C9ujeUO74qnLZoStTEplrl_45sF3_45XH1sMeta } from "/app/client/pages/planner/composables/useAccountMarketingCalendar.ts?macro=true";
import { default as data_45capturerqKEkfEAHNVpT2wfmFwsEj_e_y412BECEWeaQe5NZ7QMeta } from "/app/client/pages/audience/[customer]/view/components/data-capture.vue?macro=true";
import { default as ImportContactsOneschemaModalnuAl12X8OdRQxzteflIaai9D8lMeyhNdsMkUk2DDtgoMeta } from "/app/client/pages/audience/components/ImportContactsOneschemaModal.vue?macro=true";
import { default as useAdvancedFiltersWithGroupsCp_45wYsra0q_BdI07upzQS0AtxoXAUdhdPShq1lrldJ8Meta } from "/app/client/pages/audience/composables/useAdvancedFiltersWithGroups.js?macro=true";
import { default as CampaignConfirmationSection6qC3wC8o1o7m6pcGmSLDNoPoklLbP04k_SQMMwQLMqQMeta } from "/app/client/pages/campaigns/components/CampaignConfirmationSection.vue?macro=true";
import { default as CampaignGamificationSectionFyebVKNfyrnnBwUeTJ5iMyhyVzL4biIa5qti7vY794YMeta } from "/app/client/pages/campaigns/components/CampaignGamificationSection.vue?macro=true";
import { default as useAdvancedSettingsSnapshotJGw7z6VFVVD7eoDaM4hiU3hqH8Lgxr_rj4nlDYvrMusMeta } from "/app/client/pages/campaigns/composables/useAdvancedSettingsSnapshot.ts?macro=true";
import { default as usePopulateGamificationDatavbRQQslK6PFjoa6W3nzp7fqRGTFJG8Aki68YnCLGy0cMeta } from "/app/client/pages/campaigns/composables/usePopulateGamificationData.ts?macro=true";
import { default as MessagingCardtIOecrFsEHfgM97mgm_45wSmGF2HNnaNC13JtoytvNL84Meta } from "/app/client/pages/audience/[customer]/view/components/MessagingCard.vue?macro=true";
import { default as validateInviteForm1ybIWdLAPcmz8_36sFHGqe9UpaLewXESbrX5cOYAAGIMeta } from "/app/client/pages/authenticate/invite/composables/validateInviteForm.ts?macro=true";
import { default as customerProfileDataCaptureKkRMlm29rKGb3TZDAVco6SKhQhiv6Pm8O5WSKj_NxNoMeta } from "/app/client/pages/audience/[customer]/view/customerProfileDataCapture.vue?macro=true";
import { default as OrderDetailsModalDehafDSqgqdxDHf7ia7P2apHlG7zScvxxg7zWPHo2kAMeta } from "/app/client/pages/audience/[customer]/view/components/OrderDetailsModal.vue?macro=true";
import { default as SelectDateRangeModal4O1HZ4y1oOndQR_de5G_4kh_45XeibyUw6kEGKGpiNirgMeta } from "/app/client/pages/audience/[customer]/view/components/SelectDateRangeModal.vue?macro=true";
import { default as EventTicketSalesChart7CFFP1UdgdfgTSFioAVCywuPQndJ81FpISE0nAaMYiwMeta } from "/app/client/pages/events/components/view/ticket-sales/EventTicketSalesChart.vue?macro=true";
import { default as EventTicketTypesChartJPaxb4BaFK8killcC9lqNGNv5dtf1MVRvvg4MplKI_45YMeta } from "/app/client/pages/events/components/view/ticket-sales/EventTicketTypesChart.vue?macro=true";
import { default as EventTicketSalesOverview6pDCao8NLisdJCE2G664KGwsyg9CMoSsLEFHWsNs5doMeta } from "/app/client/pages/events/components/view/ticket-sales/EventTicketSalesOverview.vue?macro=true";
import { default as EventTicketSalesAttribution1M4R5PYcWdyqMZkLDz5Dcxvt8tWW_45TdY9TTm4BuSadEMeta } from "/app/client/pages/events/components/view/ticket-sales/EventTicketSalesAttribution.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "/pages",
    path: "/",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/index.vue")
  },
  {
    name: "/pages/[...all]",
    path: "/:all(.*)*",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/[...all].vue")
  },
  {
    name: "/pages/events",
    path: "/events",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/index.vue")
  },
  {
    name: "/pages/events/create",
    path: "/events/create",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/create.vue")
  },
  {
    name: "/pages/planner",
    path: "/planner",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/planner/index.vue")
  },
  {
    name: "/pages/audience",
    path: "/audience",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/index.vue")
  },
  {
    name: "/pages/campaigns",
    path: "/campaigns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/index.vue")
  },
  {
    name: "/pages/campaigns/create",
    path: "/campaigns/create",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/create.vue")
  },
  {
    name: "/pages/events/past",
    path: "/events/past",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/past/index.vue")
  },
  {
    name: "/pages/authenticate/login",
    path: "/authenticate/login",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/login.vue")
  },
  {
    name: "/pages/audience/tags",
    path: "/audience/tags",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/tags/index.vue")
  },
  {
    name: "/pages/authenticate/signup",
    path: "/authenticate/signup",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/signup.vue")
  },
  {
    name: "/pages/campaigns/view/[oid]",
    path: "/campaigns/view/:oid()",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/view/[oid].vue")
  },
  {
    name: "/pages/custom-planner",
    path: "/custom-planner",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/custom-planner/index.vue")
  },
  {
    name: "/pages/events/archived",
    path: "/events/archived",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/archived/index.vue")
  },
  {
    name: "/pages/audience/filters",
    path: "/audience/filters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/filters/index.vue")
  },
  {
    name: "/pages/campaigns/update/[oid]",
    path: "/campaigns/update/:oid()",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/update/[oid].vue")
  },
  {
    name: "/pages/campaigns/view/signups",
    path: "/campaigns/view/signups",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/view/signups.vue")
  },
  {
    name: "/pages/events/[eventoid]/edit",
    path: "/events/:eventoid()/edit",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/[eventoid]/edit.vue")
  },
  {
    name: "/pages/campaigns/email-example",
    path: "/campaigns/email-example",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/email-example.vue")
  },
  {
    name: "/pages/campaigns/view/insights",
    path: "/campaigns/view/insights",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/view/insights.vue")
  },
  {
    name: "/pages/events/composables/inde",
    path: "/events/composables",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/composables/index.ts")
  },
  {
    name: "/pages/campaigns/view/dashboard",
    path: "/campaigns/view/dashboard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/view/dashboard.vue")
  },
  {
    name: "/pages/authenticate/email-verify",
    path: "/authenticate/email-verify",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/email-verify.vue")
  },
  {
    name: "/pages/authenticate/invite",
    path: "/authenticate/invite",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/invite/index.vue")
  },
  {
    name: "/pages/events/types/calendarItem",
    path: "/events/types/calendarItems",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/types/calendarItems.ts")
  },
  {
    name: "/pages/audience/utils/criteriaMen",
    path: "/audience/utils/criteriaMenu",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/utils/criteriaMenu.js")
  },
  {
    name: "/pages/audience/utils/filterNamin",
    path: "/audience/utils/filterNaming",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/utils/filterNaming.ts")
  },
  {
    name: "/pages/authenticate/ResetPassword",
    path: "/authenticate/ResetPassword",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/ResetPassword.vue")
  },
  {
    name: "/pages/authenticate/billing-details",
    path: "/authenticate/billing-details",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/billing-details.vue")
  },
  {
    name: "/pages/authenticate/forgot-password",
    path: "/authenticate/forgot-password",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/forgot-password.vue")
  },
  {
    name: "/pages/campaigns/view/registrations",
    path: "/campaigns/view/registrations",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/view/registrations.vue")
  },
  {
    name: "/pages/events/[eventoid]/view/event",
    path: "/events/:eventoid()/view/event",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/[eventoid]/view/event.vue")
  },
  {
    name: "/pages/events/[eventoid]/view/group",
    path: "/events/:eventoid()/view/group",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/[eventoid]/view/group.vue")
  },
  {
    name: "/pages/audience/data-capture-example",
    path: "/audience/data-capture-example",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/data-capture-example.vue")
  },
  {
    name: "/pages/audience/[customer]/view",
    path: "/audience/:customer()/view",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/index.vue")
  },
  {
    name: "/pages/audience/components/FilterTabs",
    path: "/audience/components/FilterTabs",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FilterTabs.vue")
  },
  {
    name: "/pages/authenticate/import-sales-data",
    path: "/authenticate/import-sales-data",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/import-sales-data.vue")
  },
  {
    name: "/pages/authenticate/invite-sent",
    path: "/authenticate/invite-sent",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/invite-sent/index.vue")
  },
  {
    name: "/pages/events/components/EditEventGroup",
    path: "/events/components/EditEventGroup",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/EditEventGroup.vue")
  },
  {
    name: "/pages/events/components/view/OrdersTab",
    path: "/events/components/view/OrdersTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/OrdersTab.vue")
  },
  {
    name: "/pages/audience/components/FilterTagList",
    path: "/audience/components/FilterTagList",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FilterTagList.vue")
  },
  {
    name: "/pages/authenticate/invite-expired",
    path: "/authenticate/invite-expired",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/invite-expired/index.vue")
  },
  {
    name: "/pages/audience/[customer]/view/campaigns",
    path: "/audience/:customer()/view/campaigns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/campaigns.vue")
  },
  {
    name: "/pages/audience/components/FavoriteButton",
    path: "/audience/components/FavoriteButton",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FavoriteButton.vue")
  },
  {
    name: "/pages/audience/components/FilterListItem",
    path: "/audience/components/FilterListItem",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FilterListItem.vue")
  },
  {
    name: "/pages/audience/composables/useTagCreatio",
    path: "/audience/composables/useTagCreation",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useTagCreation.js")
  },
  {
    name: "/pages/events/components/GroupEventsModal",
    path: "/events/components/GroupEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/GroupEventsModal.vue")
  },
  {
    name: "/pages/events/components/view/InsightsTab",
    path: "/events/components/view/InsightsTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/InsightsTab.vue")
  },
  {
    name: "/pages/events/components/view/MessagesTab",
    path: "/events/components/view/MessagesTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/MessagesTab.vue")
  },
  {
    name: "/pages/events/composables/useEventMessage",
    path: "/events/composables/useEventMessages",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/composables/useEventMessages.ts")
  },
  {
    name: "/pages/audience/components/AudienceFilters",
    path: "/audience/components/AudienceFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/AudienceFilters.vue")
  },
  {
    name: "/pages/campaigns/components/AddActionModal",
    path: "/campaigns/components/AddActionModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/AddActionModal.vue")
  },
  {
    name: "/pages/campaigns/components/AddRewardModal",
    path: "/campaigns/components/AddRewardModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/AddRewardModal.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignHeader",
    path: "/campaigns/components/CampaignHeader",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CampaignHeader.vue")
  },
  {
    name: "/pages/campaigns/components/EditFieldModal",
    path: "/campaigns/components/EditFieldModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/EditFieldModal.vue")
  },
  {
    name: "/pages/events/components/DeleteEventsModal",
    path: "/events/components/DeleteEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/DeleteEventsModal.vue")
  },
  {
    name: "/pages/events/components/ImportEventsModal",
    path: "/events/components/ImportEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/ImportEventsModal.vue")
  },
  {
    name: "/pages/events/composables/useEventCampaign",
    path: "/events/composables/useEventCampaigns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/composables/useEventCampaigns.ts")
  },
  {
    name: "/pages/planner/components/PlannerDayDrawer",
    path: "/planner/components/PlannerDayDrawer",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/planner/components/PlannerDayDrawer.vue")
  },
  {
    name: "/pages/audience/components/ContactFormModal",
    path: "/audience/components/ContactFormModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/ContactFormModal.vue")
  },
  {
    name: "/pages/audience/components/EditFanTagsModal",
    path: "/audience/components/EditFanTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/EditFanTagsModal.vue")
  },
  {
    name: "/pages/audience/components/FanMassEditModal",
    path: "/audience/components/FanMassEditModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FanMassEditModal.vue")
  },
  {
    name: "/pages/audience/composables/useActiveFilter",
    path: "/audience/composables/useActiveFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useActiveFilters.js")
  },
  {
    name: "/pages/authenticate/components/connect-card",
    path: "/authenticate/components/connect-card",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/components/connect-card.vue")
  },
  {
    name: "/pages/campaigns/components/EditActionModal",
    path: "/campaigns/components/EditActionModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/EditActionModal.vue")
  },
  {
    name: "/pages/campaigns/components/EditButtonModal",
    path: "/campaigns/components/EditButtonModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/EditButtonModal.vue")
  },
  {
    name: "/pages/campaigns/composables/useGamificatio",
    path: "/campaigns/composables/useGamification",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/composables/useGamification.js")
  },
  {
    name: "/pages/events/components/ArchiveEventsModal",
    path: "/events/components/ArchiveEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/ArchiveEventsModal.vue")
  },
  {
    name: "/pages/audience/[customer]/view/posPurchases",
    path: "/audience/:customer()/view/posPurchases",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/posPurchases.vue")
  },
  {
    name: "/pages/audience/composables/useContactColumn",
    path: "/audience/composables/useContactColumns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useContactColumns.ts")
  },
  {
    name: "/pages/campaigns/components/AdvancedSettings",
    path: "/campaigns/components/AdvancedSettings",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/AdvancedSettings.vue")
  },
  {
    name: "/pages/campaigns/composables/useCampaignLogi",
    path: "/campaigns/composables/useCampaignLogic",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/composables/useCampaignLogic.js")
  },
  {
    name: "/pages/events/components/view/DataCaptureTab",
    path: "/events/components/view/DataCaptureTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/DataCaptureTab.vue")
  },
  {
    name: "/pages/events/components/view/TicketSalesTab",
    path: "/events/components/view/TicketSalesTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/TicketSalesTab.vue")
  },
  {
    name: "/pages/audience/components/FanMassDeleteModal",
    path: "/audience/components/FanMassDeleteModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FanMassDeleteModal.vue")
  },
  {
    name: "/pages/audience/composables/useAdvancedFilter",
    path: "/audience/composables/useAdvancedFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useAdvancedFilters.js")
  },
  {
    name: "/pages/audience/composables/useResourceOption",
    path: "/audience/composables/useResourceOptions",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useResourceOptions.js")
  },
  {
    name: "/pages/campaigns/components/EditCheckboxModal",
    path: "/campaigns/components/EditCheckboxModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/EditCheckboxModal.vue")
  },
  {
    name: "/pages/campaigns/components/GamificationStats",
    path: "/campaigns/components/GamificationStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/GamificationStats.vue")
  },
  {
    name: "/pages/campaigns/components/RedirectDelayCard",
    path: "/campaigns/components/RedirectDelayCard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/RedirectDelayCard.vue")
  },
  {
    name: "/pages/events/components/DuplicateEventsModal",
    path: "/events/components/DuplicateEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/DuplicateEventsModal.vue")
  },
  {
    name: "/pages/events/composables/useEventDataCapture",
    path: "/events/composables/useEventDataCaptures",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/composables/useEventDataCaptures.ts")
  },
  {
    name: "/pages/events/composables/useMarketingCalenda",
    path: "/events/composables/useMarketingCalendar",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/composables/useMarketingCalendar.ts")
  },
  {
    name: "/pages/audience/components/AudienceFilterGroup",
    path: "/audience/components/AudienceFilterGroup",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/AudienceFilterGroup.vue")
  },
  {
    name: "/pages/audience/composables/useResourceFetcher",
    path: "/audience/composables/useResourceFetchers",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useResourceFetchers.js")
  },
  {
    name: "/pages/audience/tags/components/GroupTagsModal",
    path: "/audience/tags/components/GroupTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/tags/components/GroupTagsModal.vue")
  },
  {
    name: "/pages/audience/tags/components/MergeTagsModal",
    path: "/audience/tags/components/MergeTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/tags/components/MergeTagsModal.vue")
  },
  {
    name: "/pages/campaigns/components/DesktopLayoutModal",
    path: "/campaigns/components/DesktopLayoutModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/DesktopLayoutModal.vue")
  },
  {
    name: "/pages/campaigns/components/InviteFriendsModal",
    path: "/campaigns/components/InviteFriendsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/InviteFriendsModal.vue")
  },
  {
    name: "/pages/campaigns/composables/useCampaignAction",
    path: "/campaigns/composables/useCampaignActions",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/composables/useCampaignActions.ts")
  },
  {
    name: "/pages/events/composables/useEventCustomEntrie",
    path: "/events/composables/useEventCustomEntries",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/composables/useEventCustomEntries.ts")
  },
  {
    name: "/pages/audience/[customer]/view/ticketPurchases",
    path: "/audience/:customer()/view/ticketPurchases",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/ticketPurchases.vue")
  },
  {
    name: "/pages/audience/composables/useFilterCompressio",
    path: "/audience/composables/useFilterCompression",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useFilterCompression.ts")
  },
  {
    name: "/pages/audience/tags/components/DeleteTagsModal",
    path: "/audience/tags/components/DeleteTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/tags/components/DeleteTagsModal.vue")
  },
  {
    name: "/pages/audience/tags/components/RenameTagsModal",
    path: "/audience/tags/components/RenameTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/tags/components/RenameTagsModal.vue")
  },
  {
    name: "/pages/campaigns/components/AddCustomFieldModal",
    path: "/campaigns/components/AddCustomFieldModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/AddCustomFieldModal.vue")
  },
  {
    name: "/pages/campaigns/components/DeleteCampaignModal",
    path: "/campaigns/components/DeleteCampaignModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/DeleteCampaignModal.vue")
  },
  {
    name: "/pages/events/components/ClearTicketOrdersModal",
    path: "/events/components/ClearTicketOrdersModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/ClearTicketOrdersModal.vue")
  },
  {
    name: "/pages/audience/components/FilterConstraintInput",
    path: "/audience/components/FilterConstraintInput",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FilterConstraintInput.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignPreviewFrame",
    path: "/campaigns/components/CampaignPreviewFrame",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CampaignPreviewFrame.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignTypeSelector",
    path: "/campaigns/components/CampaignTypeSelector",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CampaignTypeSelector.vue")
  },
  {
    name: "/pages/events/components/ImportTicketOrdersModal",
    path: "/events/components/ImportTicketOrdersModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/ImportTicketOrdersModal.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/events",
    path: "/audience/:customer()/view/components/events",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/events.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignSignUpSection",
    path: "/campaigns/components/CampaignSignUpSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CampaignSignUpSection.vue")
  },
  {
    name: "/pages/events/components/view/MarketingPlannerTab",
    path: "/events/components/view/MarketingPlannerTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/MarketingPlannerTab.vue")
  },
  {
    name: "/pages/audience/components/AudienceAdvancedFilters",
    path: "/audience/components/AudienceAdvancedFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/AudienceAdvancedFilters.vue")
  },
  {
    name: "/pages/audience/components/AudienceFilterCondition",
    path: "/audience/components/AudienceFilterCondition",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/AudienceFilterCondition.vue")
  },
  {
    name: "/pages/audience/components/AudienceFilterGroupItem",
    path: "/audience/components/AudienceFilterGroupItem",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/AudienceFilterGroupItem.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignDetailsSection",
    path: "/campaigns/components/CampaignDetailsSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CampaignDetailsSection.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/activity",
    path: "/audience/:customer()/view/components/activity",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/activity.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/overview",
    path: "/audience/:customer()/view/components/overview",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/overview.vue")
  },
  {
    name: "/pages/audience/components/AddFanToMessageListModal",
    path: "/audience/components/AddFanToMessageListModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/AddFanToMessageListModal.vue")
  },
  {
    name: "/pages/audience/components/FilterConstraintSelector",
    path: "/audience/components/FilterConstraintSelector",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/FilterConstraintSelector.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/purchases",
    path: "/audience/:customer()/view/components/purchases",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/purchases.vue")
  },
  {
    name: "/pages/audience/filters/components/DeleteFilterModal",
    path: "/audience/filters/components/DeleteFilterModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/filters/components/DeleteFilterModal.vue")
  },
  {
    name: "/pages/audience/filters/components/RenameFilterModal",
    path: "/audience/filters/components/RenameFilterModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/filters/components/RenameFilterModal.vue")
  },
  {
    name: "/pages/audience/utils/conditionSearchPickerResolutio",
    path: "/audience/utils/conditionSearchPickerResolution",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/utils/conditionSearchPickerResolution.js")
  },
  {
    name: "/pages/campaigns/components/CreateCampaignWidgetModal",
    path: "/campaigns/components/CreateCampaignWidgetModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CreateCampaignWidgetModal.vue")
  },
  {
    name: "/pages/planner/composables/useAccountMarketingCalenda",
    path: "/planner/composables/useAccountMarketingCalendar",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/planner/composables/useAccountMarketingCalendar.ts")
  },
  {
    name: "/pages/audience/[customer]/view/components/data-capture",
    path: "/audience/:customer()/view/components/data-capture",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/data-capture.vue")
  },
  {
    name: "/pages/audience/components/ImportContactsOneschemaModal",
    path: "/audience/components/ImportContactsOneschemaModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/components/ImportContactsOneschemaModal.vue")
  },
  {
    name: "/pages/audience/composables/useAdvancedFiltersWithGroup",
    path: "/audience/composables/useAdvancedFiltersWithGroups",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/composables/useAdvancedFiltersWithGroups.js")
  },
  {
    name: "/pages/campaigns/components/CampaignConfirmationSection",
    path: "/campaigns/components/CampaignConfirmationSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CampaignConfirmationSection.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignGamificationSection",
    path: "/campaigns/components/CampaignGamificationSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/components/CampaignGamificationSection.vue")
  },
  {
    name: "/pages/campaigns/composables/useAdvancedSettingsSnapsho",
    path: "/campaigns/composables/useAdvancedSettingsSnapshot",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/composables/useAdvancedSettingsSnapshot.ts")
  },
  {
    name: "/pages/campaigns/composables/usePopulateGamificationDat",
    path: "/campaigns/composables/usePopulateGamificationData",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/campaigns/composables/usePopulateGamificationData.ts")
  },
  {
    name: "/pages/audience/[customer]/view/components/MessagingCard",
    path: "/audience/:customer()/view/components/MessagingCard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/MessagingCard.vue")
  },
  {
    name: "/pages/authenticate/invite/composables/validateInviteFor",
    path: "/authenticate/invite/composables/validateInviteForm",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/authenticate/invite/composables/validateInviteForm.ts")
  },
  {
    name: "/pages/audience/[customer]/view/customerProfileDataCapture",
    path: "/audience/:customer()/view/customerProfileDataCapture",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/customerProfileDataCapture.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/OrderDetailsModal",
    path: "/audience/:customer()/view/components/OrderDetailsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/OrderDetailsModal.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/SelectDateRangeModal",
    path: "/audience/:customer()/view/components/SelectDateRangeModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/audience/[customer]/view/components/SelectDateRangeModal.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketSalesChart",
    path: "/events/components/view/ticket-sales/EventTicketSalesChart",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/ticket-sales/EventTicketSalesChart.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketTypesChart",
    path: "/events/components/view/ticket-sales/EventTicketTypesChart",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/ticket-sales/EventTicketTypesChart.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketSalesOverview",
    path: "/events/components/view/ticket-sales/EventTicketSalesOverview",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/ticket-sales/EventTicketSalesOverview.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketSalesAttribution",
    path: "/events/components/view/ticket-sales/EventTicketSalesAttribution",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/app/client/pages/events/components/view/ticket-sales/EventTicketSalesAttribution.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/audience/:customer/view/overview",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]